import { render, staticRenderFns } from "./ArchivedInvoices.vue?vue&type=template&id=90f9ecc8&scoped=true&"
import script from "./ArchivedInvoices.vue?vue&type=script&lang=js&"
export * from "./ArchivedInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedInvoices.vue?vue&type=style&index=0&id=90f9ecc8&prod&lang=scss&"
import style1 from "./ArchivedInvoices.vue?vue&type=style&index=1&id=90f9ecc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f9ecc8",
  null
  
)

export default component.exports